import { motion } from "framer-motion";
import { Phone, PhoneOff, Video } from "lucide-react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";

interface IncomingCallOverlayProps {
  displayName: string;
  avatarUrl: string | null;
  isVideo: boolean;
  onAccept: () => void;
  onDecline: () => void;
}

export const IncomingCallOverlay = ({
  displayName, avatarUrl, isVideo, onAccept, onDecline,
}: IncomingCallOverlayProps) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-black/90 backdrop-blur-2xl"
    >
      <motion.div
        className="relative mb-8"
        animate={{ scale: [1, 1.05, 1] }}
        transition={{ duration: 2, repeat: Infinity }}
      >
        <motion.div
          className="absolute inset-0 rounded-full bg-green-500/20"
          animate={{ scale: [1, 1.8, 1], opacity: [0.4, 0, 0.4] }}
          transition={{ duration: 2, repeat: Infinity }}
        />
        <Avatar className="w-32 h-32 ring-4 ring-green-500/40">
          <AvatarImage src={avatarUrl || undefined} />
          <AvatarFallback className="bg-primary/20 text-white text-4xl font-semibold">
            {displayName.charAt(0).toUpperCase()}
          </AvatarFallback>
        </Avatar>
      </motion.div>

      <h2 className="text-2xl font-bold text-white mb-2">{displayName}</h2>
      <p className="text-white/60 text-base mb-12">
        {isVideo ? "Videochiamata in arrivo..." : "Chiamata in arrivo..."}
      </p>

      <div className="flex items-center gap-12">
        <button
          onClick={onDecline}
          className="flex flex-col items-center gap-2"
        >
          <div className="w-16 h-16 rounded-full bg-red-500 flex items-center justify-center shadow-lg shadow-red-500/30 active:scale-90 transition-transform">
            <PhoneOff className="w-7 h-7 text-white" />
          </div>
          <span className="text-white/60 text-xs">Rifiuta</span>
        </button>

        <button
          onClick={onAccept}
          className="flex flex-col items-center gap-2"
        >
          <motion.div
            className="w-16 h-16 rounded-full bg-green-500 flex items-center justify-center shadow-lg shadow-green-500/30"
            animate={{ scale: [1, 1.1, 1] }}
            transition={{ duration: 1.5, repeat: Infinity }}
          >
            {isVideo ? <Video className="w-7 h-7 text-white" /> : <Phone className="w-7 h-7 text-white" />}
          </motion.div>
          <span className="text-white/60 text-xs">Rispondi</span>
        </button>
      </div>
    </motion.div>
  );
};
